import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./loyaltyFormModal.css";
import { toast } from "react-toastify";
import { uploadToS3 } from "../utils/s3Uploader";

const SubscriberFormModal = ({ onClose }) => {
  const form = useRef();
  const [formData, setFormData] = useState({
    subscriber_name: "",
    subscriber_email: "",
    subscriber_phone: ""
  });

  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setUploadedFiles((prev) => [...prev, ...files]);
    e.target.value = null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const fileLinks = [];

      for (let file of uploadedFiles) {
        const url = await uploadToS3(file);
        fileLinks.push(`📎 ${file.name}: ${url}`);
      }

      await emailjs.send(
        "service_r1kg6tc",          // ✅ Your EmailJS Service ID
        "template_3korvfq",      // ✅ Create this template in EmailJS
        {
          subscriber_name: formData.subscriber_name,
          subscriber_email: formData.subscriber_email,
          subscriber_phone: formData.subscriber_phone,
          file_links: fileLinks.join("\n")
        },
        "0fmWeTGurdz-26yqR"         // ✅ Your EmailJS Public Key
      );

      toast.success("✅ Subscriber application sent!");
      setUploadedFiles([]);
      setFormData({ subscriber_name: "", subscriber_email: "", subscriber_phone: "" });
      onClose();
    } catch (err) {
      console.error("❌ Upload or EmailJS error:", err);
      toast.error("❌ Submission failed. Please try again.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>📩 Subscriber Sign-Up</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="subscriber_name"
            placeholder="Full Name"
            value={formData.subscriber_name}
            onChange={(e) =>
              setFormData({ ...formData, subscriber_name: e.target.value })
            }
            required
          />
          <input
            type="email"
            name="subscriber_email"
            placeholder="Email"
            value={formData.subscriber_email}
            onChange={(e) =>
              setFormData({ ...formData, subscriber_email: e.target.value })
            }
            required
          />
          <input
            type="tel"
            name="subscriber_phone"
            placeholder="Phone"
            value={formData.subscriber_phone}
            onChange={(e) =>
              setFormData({ ...formData, subscriber_phone: e.target.value })
            }
            required
          />

          <label className="upload-label">
            Upload ID or Driver's Licence (PDF/Image):
            <input
              type="file"
              accept="image/*,.pdf"
              multiple
              onChange={handleFileChange}
            />
          </label>

          <ul className="file-list">
            {uploadedFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>

          <button type="submit">Submit</button>
          <button type="button" className="close-btn" onClick={onClose}>
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default SubscriberFormModal;
